import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/TableFilter.module.css";
import { UserData } from "../../../Context/DataContext";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import useWindowDimensions from "../../Footer/footer";
function TableFilter({
  setFilter,
  OnAddNewAsset,
  setAsset,
  setBen,
  component,
  customerStyle,
  tableName,
}) {
  const userData = UserData();
  const [assetType, setAssetType] = useState("");
  const assetChange = (event) => {
    setAssetType(event.target.value);
  };
  const { height, width } = useWindowDimensions();

  const websiteCurrentLang = useContext(LanguageContext).language;
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  const [content, setContent] = useState(
    websiteCurrentLang.content.User.Assets.TableFilter
  );

  useEffect(() => {
    setContent(websiteCurrentLang.content.User.Assets.TableFilter);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const [beneficiary, setBeneficiary] = useState("");
  const beneficiaryChange = (event) => {
    setBeneficiary(event.target.value);
  };
  const clearAsset = () => {
    setAssetType("");
    setAsset("");
  };
  const clearBen = () => {
    setBeneficiary("");
    setBen("");
  };
  return (
    <div
      className={styles.filter_div}
      style={
        tableName === "assets" && width < 980
          ? {
              borderRadius: "20px",
            }
          : customerStyle === "customer"
          ? { justifyContent: "space-around" }
          : { justifyContent: "space-between" }
      }
    >
      <div className={styles.search}>
        <input
          onChange={(e) => setFilter(e.target.value)}
          placeholder={dublicatedcontent.dublicatedText65}
          className={styles.referral_input_input}
          style={
            customerStyle === "customer"
              ? {
                  width: "1100px",
                  paddingLeft: "70px",
                }
              : {
                  width: "350px",
                }
          }
        ></input>
      </div>
      {component !== "referral" && component !== "beneficiary" ? (
        <button
          disabled={userData.isFreezed}
          onClick={OnAddNewAsset}
          className={styles.add}
        >
          <div className={styles.plus_logo} />
          <div>{content.TableFilterText2}</div>
        </button>
      ) : (
        <></>
      )}
      {component !== "beneficiary" && (
        <div className={styles.select_field}>
          {component === "referral" ? (
            <select
              className={`${styles.select} ${assetType ? styles.selected : ""}`}
              name="user_status"
              value={assetType}
              onChange={(e) => {
                setAsset(e.target.value);
                assetChange(e);
              }}
            >
              {/* to make it work with referral component */}
              <option value="">{content.statusSelection1}</option>
              <option value="Trial Account">{content.statusSelection2}</option>
              <option value="Customer In Cancelation Period">
                {content.statusSelection3}
              </option>
              <option value="Subscribed">{content.statusSelection4}</option>
              <option value="Invited">{content.statusSelection5}</option>
            </select>
          ) : (
            <select
              className={`${styles.select} ${assetType ? styles.selected : ""}`}
              name="asset_type"
              value={assetType}
              onChange={(e) => {
                setAsset(e.target.value);
                assetChange(e);
              }}
            >
              <option value="">{dublicatedcontent.dublicatedText58}</option>
              <option value="Bank Account">{content.TableFilterText4}</option>
              <option value="Crypto Wallet">{content.TableFilterText5}</option>
              <option value="Life Insurance">{content.TableFilterText6}</option>
              <option value="Investment Account">
                {content.TableFilterText7}
              </option>
              <option value="Company Shares">
                {dublicatedcontent.dublicatedText5}
              </option>
              <option value="NFT">NFT</option>
              <option value="Password Manager">
                {content.TableFilterText9}
              </option>
              <option value="Password">{dublicatedcontent.password}</option>{" "}
              <option value="Online storage">
                {dublicatedcontent.online_storage}
              </option>
              <option value="Real Estate">
                {dublicatedcontent.dublicatedText4}
              </option>
              <option value="Retirement Plan">
                {content.TableFilterText12}
              </option>
              <option value="Physical Vault">
                {content.TableFilterText13}
              </option>
              <option value="Your Will">{content.TableFilterText14}</option>{" "}
              {/* New types. `value` is the stored string; the label is copy, so it
                  can be reworded without migrating anything. */}
              <option value="Company">
                {dublicatedcontent.company}
              </option>
              <option value="Vehicle">
                {dublicatedcontent.vehicle}
              </option>
              <option value="Precious Objects">
                {dublicatedcontent.precious_objects}
              </option>
              <option value="Business Ownership">
                {dublicatedcontent.business_ownership}
              </option>
              <option value="Loans Receivable">
                {dublicatedcontent.loans_receivable}
              </option>
              <option value="Cash">
                {dublicatedcontent.cash}
              </option>
              <option value="Intellectual Property">
                {dublicatedcontent.intellectual_property}
              </option>
              <option value="Employee Benefits">
                {dublicatedcontent.employee_benefits}
              </option>
              <option value="Other">{content.TableFilterText15}</option>
            </select>
          )}

          {assetType && (
            <div
              className={styles.filter_clear}
              onClick={(e) => clearAsset()}
            ></div>
          )}
        </div>
      )}
      {component !== "beneficiary" && (
        <div className={styles.select_field}>
          {component === "referral" ? (
            <select
              className={`${styles.select} ${
                beneficiary ? styles.selected : ""
              }`}
              value={beneficiary}
              name="reward_status"
              onChange={(e) => {
                setBen(e.target.value);
                beneficiaryChange(e);
              }}
            >
              <option value="">{content.rewardStatusSelection1}</option>
              <option value="Not Eligible">
                {content.rewardStatusSelection2}
              </option>
              <option value="Your Subscription Got Extended!">
                {content.rewardStatusSelection3}
              </option>{" "}
              <option value="Pending">{content.rewardStatusSelection4}</option>
              <option value="Unclaimed">
                {content.rewardStatusSelection5}
              </option>
            </select>
          ) : (
            <select
              className={`${styles.select} ${
                beneficiary ? styles.selected : ""
              }`}
              value={beneficiary}
              name="beneficiary"
              onChange={(e) => {
                setBen(e.target.value);
                beneficiaryChange(e);
              }}
            >
              <option value="">{content.TableFilterText10}</option>
              {userData.UserData.beneficiaries.map((item) => (
                <option key={item.user_id} value={item.user_id}>
                  {item.name}
                </option>
              ))}
            </select>
          )}

          {beneficiary && (
            <div
              className={styles.filter_clear}
              onClick={(e) => clearBen()}
            ></div>
          )}
        </div>
      )}
    </div>
  );
}

export default TableFilter;
